module.exports = __webpack_public_path__ + "img/4.c7aba105.jpg";